import { FileUploader } from "react-drag-drop-files";
import { ReactComponent as PlusIcon } from "../../../../assets/icons/plus.svg";

export function FileUploadView({ onChange, onTypeError, fileTypes, disabled }: { onChange: (file: File[]) => void, onTypeError: () => void, fileTypes: string[], disabled: boolean }) {
  return (
    <div className="px-6 h-[120px]">
      <FileUploader multiple handleChange={onChange} onTypeError={onTypeError} name="file" types={fileTypes} disabled={disabled}>
        <div className="border border-PraxisTerracotta h-full cursor-pointer p-7 flex flex-col gap-4 justify-center items-center bg-background2 rounded-lg">
          <div className="border rounded-[4px] border-PraxisTerracotta w-5 h-5 flex items-center justify-center">
            <PlusIcon className="w-4 h-4 [&_path]:fill-PraxisTerracotta" />
          </div>
          <div className="text-sm text-center text-[#1C1B18] flex flex-col gap-0.5">
            <span>Drop files here to add</span> 
            <span className="text-text-gray-500 uppercase text-[10px]">PDF only</span>
          </div>
        </div>
      </FileUploader>
    </div>
  )
}